var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContactBanner',{attrs:{"imageList":this.config.banner_top.imageList}}),_c('ContactTitle1'),_c('JoinContent'),_c('ContactTitle2'),_c('ContactContent'),_c('ContactBottom'),_c('ContactBanner3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }